export const JOBS_TABS_MAP: WordingMap<JobsTabs> = {
  invites: {
    US: {
      full: 'avail checks',
      short: 'avail checks',
    },
    UK: {
      full: 'avail checks',
      short: 'avail checks',
    },
  },
  status_checks: {
    US: {
      full: 'status checks',
      short: 'status checks',
    },
    UK: {
      full: 'status checks',
      short: 'status checks',
    },
  },
} as const;
